import React from "react";
import { Page, PageHeader } from "components/ui/Page";
import { Column, Columns } from "components/Columns";
import { LargeSpacer } from "components/ui/VerticalSpacers";

import { GraduationChecklistCard } from "components/cards/GraduationChecklistCard";

export default function AcademicGraduationChecklistPage() {
  return (
    <Page>
      <PageHeader>
        <a href="/academics">My Academics</a> &raquo; Graduation Checklist
      </PageHeader>
      <LargeSpacer />
      <Columns>
        <Column>
          <GraduationChecklistCard />
        </Column>
      </Columns>
    </Page>
  );
}
AcademicGraduationChecklistPage.displayName = "AcademicGraduationChecklistPage";
